export default __webpack_public_path__ + "static/media/warning_info.daf801f9.svg";